/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_PlansInputs */

const en_for_whom_tag_plans = /** @type {(inputs: For_Whom_Tag_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans`)
};

const pl_for_whom_tag_plans = /** @type {(inputs: For_Whom_Tag_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany`)
};

/**
* | output |
* | --- |
* | "Plans" |
*
* @param {For_Whom_Tag_PlansInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_plans = /** @type {((inputs?: For_Whom_Tag_PlansInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_PlansInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_plans(inputs)
	return en_for_whom_tag_plans(inputs)
});